/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Cta_LedeInputs */

const en_how_we_work_cta_lede = /** @type {(inputs: How_We_Work_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with one problem. We’ll scope the first phase together.`)
};

const lv_how_we_work_cta_lede = /** @type {(inputs: How_We_Work_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sāciet ar vienu problēmu. Pirmo posmu noteiksim kopā.`)
};

/**
* | output |
* | --- |
* | "Start with one problem. We’ll scope the first phase together." |
*
* @param {How_We_Work_Cta_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_cta_lede = /** @type {((inputs?: How_We_Work_Cta_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Cta_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_cta_lede(inputs)
	return en_how_we_work_cta_lede(inputs)
});